import { render, staticRenderFns } from "./ProductBrand.vue?vue&type=template&id=3c47b3d6&scoped=true"
import script from "./ProductBrand.vue?vue&type=script&lang=js"
export * from "./ProductBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c47b3d6",
  null
  
)

export default component.exports